import { AnswersAndQuestionFlow, AssessmentQuestion, UnitPref } from 'fitbeat.models';

export const DATE_OF_BIRTH = 'dob';
export const HEIGHT = 'height';
export const WHATS_YOUR_DATE_OF_BIRTH = 'whats-your-date-of-birth';
export const WHATS_YOUR_UNIT_PREF = 'whats-your-unit_pref';

export const WHATS_YOUR_HEIGHT = 'whats-your-height';
export const WHATS_YOUR_GENDER = 'whats-your-gender';
export const WHAT_SHAPE_YOUR_IN = 'what-shape-your-in';
export const PICKUP_MASS_EASILY = 'pickup-mass-easily';
export const SHOULDERS_WIDER_THAN_HIPS = 'shoulders-wider-than-hips';
export const WRIST_ENCIRCLE = 'wrist-encircle';
export const WEIGHT_PATTERN = 'weight-pattern';
export const BODY_SHAPE = 'body-shape';
export const CONDITIONED_ATHLETE = 'conditioned-athlete';
export enum CONDITIONED_ATHLETE_ANSWERS {
    CONDITIONED_ATHLETE_TRUE = 'isConditionedAthlete',
    CONDITIONED_ATHLETE_FALSE = 'no',
}

const bodyAssessmentQuestions = [
    new AssessmentQuestion(WHATS_YOUR_DATE_OF_BIRTH, 'whatsYourDateOfBirth', [
        new AnswersAndQuestionFlow(DATE_OF_BIRTH, WHATS_YOUR_HEIGHT, false),
    ], true, false, true),

    new AssessmentQuestion(WHATS_YOUR_UNIT_PREF, 'whatsYourUnitPref', [
        new AnswersAndQuestionFlow(UnitPref.metric, WHATS_YOUR_GENDER),
        new AnswersAndQuestionFlow(UnitPref.imperial, WHATS_YOUR_GENDER),
    ]),

    new AssessmentQuestion(WHATS_YOUR_HEIGHT, 'whatsYourHeight', [
        new AnswersAndQuestionFlow(HEIGHT, WHATS_YOUR_GENDER, false),
    ]),
    new AssessmentQuestion(WHATS_YOUR_GENDER, 'whatsYourGender', [
        new AnswersAndQuestionFlow('male', WEIGHT_PATTERN),
        new AnswersAndQuestionFlow('female', WEIGHT_PATTERN),
        new AnswersAndQuestionFlow('other', WEIGHT_PATTERN),
    ]),
    new AssessmentQuestion(WHAT_SHAPE_YOUR_IN, 'whatShapeYouInQuestion', [
        new AnswersAndQuestionFlow(CONDITIONED_ATHLETE_ANSWERS.CONDITIONED_ATHLETE_TRUE, CONDITIONED_ATHLETE),
        new AnswersAndQuestionFlow(CONDITIONED_ATHLETE_ANSWERS.CONDITIONED_ATHLETE_FALSE, CONDITIONED_ATHLETE),
    ]),
    new AssessmentQuestion(WEIGHT_PATTERN, 'weightPatternQuestion', [
        new AnswersAndQuestionFlow('troubleGainingWeight', SHOULDERS_WIDER_THAN_HIPS),
        new AnswersAndQuestionFlow('gainAndLoseWeightEasy', SHOULDERS_WIDER_THAN_HIPS),
        new AnswersAndQuestionFlow('gainWeightEasyLosingHard', SHOULDERS_WIDER_THAN_HIPS),
    ]),
    new AssessmentQuestion(SHOULDERS_WIDER_THAN_HIPS, 'shouldersWiderThanHipsQuestion', [
        new AnswersAndQuestionFlow('yes', BODY_SHAPE),
        new AnswersAndQuestionFlow('noHipsWider', BODY_SHAPE),
        new AnswersAndQuestionFlow('noHipsSame', BODY_SHAPE),
    ]),
    new AssessmentQuestion(BODY_SHAPE, 'bodyShapeQuestion', [
        new AnswersAndQuestionFlow('pencil', WRIST_ENCIRCLE),
        new AnswersAndQuestionFlow('hourGlass', WRIST_ENCIRCLE),
        new AnswersAndQuestionFlow('appleOrPear', WRIST_ENCIRCLE),
    ]),
    new AssessmentQuestion(WRIST_ENCIRCLE, 'wristEncircleQuestion', [
        new AnswersAndQuestionFlow('notTouch', ''),
        new AnswersAndQuestionFlow('justTouch', ''),
        new AnswersAndQuestionFlow('overlap', ''),
    ], false, true),
];

export const getBodyAssessmentQuestions = () => {
    return JSON.parse(JSON.stringify(bodyAssessmentQuestions));
};
